/*
 * Copyright (c) 2024 Étienne FOLIO
 * Tous droits réservés.
 *
 * Ce fichier fait partie d'un logiciel propriétaire.
 * Toute reproduction, modification ou distribution, totale ou partielle,
 * de ce fichier est interdite sans l'autorisation écrite préalable
 * de l'auteur.
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
